"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TableWithEditing = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _objectHelpers = require("../../../helpers/objectHelpers");
var _TableProps = require("./TableProps");
var _Table = require("./Table");
const _excluded = ["tableId", "tableColumns", "tableData", "inlineEditing", "customFooter", "isInitialised", "onEditHandler", "onInitHandler", "onResetHandler", "onSaveHandler", "hookFormMethods"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const TableWithEditing = _ref => {
  let {
      tableId,
      tableColumns,
      tableData,
      inlineEditing,
      customFooter = null,
      isInitialised = false,
      onEditHandler = () => {},
      onInitHandler = () => {},
      onResetHandler = () => {},
      onSaveHandler = () => {},
      hookFormMethods
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const columns = (0, _react.useMemo)(() => tableColumns, [tableColumns]);

  // A flag to track resets caused by the paginator and prevent the table from resetting.
  const skipResetRef = (0, _react.useRef)(false);
  const EditHandler = _ref2 => {
    let {
      rowIndex,
      fieldId,
      newValue
    } = _ref2;
    // Use this flag so the page doesn't reset while editing
    skipResetRef.current = true;
    const updatedData = tableData.map((row, index) => {
      if (index === rowIndex) {
        return (0, _objectHelpers.UpdateNestedProperty)({
          jsonObject: _objectSpread({}, row),
          propertyPath: fieldId,
          newValue
        });
      }
      return row;
    });
    onEditHandler({
      updatedData,
      rowIndex,
      fieldId,
      newValue
    });
  };

  /* Allow the table to be reset to the original data */
  const ResetHandler = () => {
    skipResetRef.current = true;
    onResetHandler();
  };

  /* Override the original data with the changes */
  const SaveHandler = () => {
    skipResetRef.current = true;
    onSaveHandler();
  };
  return /*#__PURE__*/_react.default.createElement(_Table.Table, _extends({
    tableId: tableId,
    columns: columns,
    showRowSelectors: true,
    hookFormMethods: hookFormMethods,
    isEditable: true,
    customFooter: customFooter,
    isInitialised: isInitialised,
    inlineEditing: inlineEditing,
    data: tableData,
    onEditHandler: EditHandler,
    onSaveHandler: SaveHandler,
    onResetHandler: ResetHandler,
    onInitHandler: onInitHandler,
    skipReset: skipResetRef.current
  }, otherProps));
};
exports.TableWithEditing = TableWithEditing;
TableWithEditing.propTypes = {
  tableId: _propTypes.default.string,
  inlineEditing: _propTypes.default.bool,
  isInitialised: _propTypes.default.bool,
  tableColumns: _TableProps.TableColumnDefinitionArrayProp,
  // eslint-disable-next-line react/forbid-prop-types
  tableData: _propTypes.default.arrayOf(_propTypes.default.any),
  customFooter: _propTypes.default.element,
  onEditHandler: _propTypes.default.func,
  onInitHandler: _propTypes.default.func,
  onResetHandler: _propTypes.default.func,
  onSaveHandler: _propTypes.default.func,
  // eslint-disable-next-line react/forbid-prop-types
  otherProps: _propTypes.default.arrayOf(_propTypes.default.any),
  // eslint-disable-next-line react/forbid-prop-types
  hookFormMethods: _propTypes.default.any
};
var _default = exports.default = TableWithEditing;